/* eslint-disable formatjs/enforce-id */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  //main header
  headerTitle: {
    id: 'kdsl',
    defaultMessage: `title`,
  },
  headerDescription: {
    id: 'dkeprp',
    defaultMessage: `description`,
  },
});

export default messages;
